import { Box, Text } from "@chakra-ui/react";
import { differenceInSeconds } from "date-fns";
import React, { useEffect, useState } from "react";

type Props = {
  date: any;
  variant: string;
  onFinish?: () => void;
  styles?: any;
};

const Countdown = ({
  date = "04/06/2019",
  variant,
  onFinish = () => {},
  styles = { value: {}, label: {} },
  ...rest
}: Props) => {
  const [state, setState] = useState({
    years: 0,
    days: 0,
    hours: 0,
    min: 0,
    sec: 0,
  });

  const calculateCountdown = (endDate: Date | number) => {
    var diff = differenceInSeconds(endDate, new Date());

    // clear countdown when date is reached
    if (diff <= 0) {
      onFinish && onFinish();
      return false;
    }

    const timeLeft = {
      years: 0,
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
    };

    // calculate time difference between now and expected date
    if (diff >= 365.25 * 86400) {
      timeLeft.years = Math.floor(diff / (365.25 * 86400));
      diff -= timeLeft.years * 365.25 * 86400;
    }
    if (diff >= 86400) {
      timeLeft.days = Math.floor(diff / 86400);
      diff -= timeLeft.days * 86400;
    }
    if (diff >= 3600) {
      timeLeft.hours = Math.floor(diff / 3600);
      diff -= timeLeft.hours * 3600;
    }
    if (diff >= 60) {
      timeLeft.min = Math.floor(diff / 60);
      diff -= timeLeft.min * 60;
    }
    timeLeft.sec = diff;

    return timeLeft;
  };

  const addLeadingZeros = (value: any) => {
    value = String(value);
    while (value.length < 2) {
      value = "0" + value;
    }
    return value;
  };

  const SingleDisplay: React.FC<{
    time: any;
    [key: string]: any;
  }> = ({ time, children, ...rest }) => {
    return (
      <Box display="inline-block" minWidth="88px" mr={7} {...rest}>
        <Text
          textAlign="center"
          fontWeight="bold"
          lineHeight="none"
          fontSize="64px"
          style={{ ...styles.value }}
        >
          {addLeadingZeros(time)}
        </Text>
        <Text textAlign="center" fontSize="sm" style={styles.label}>
          {children}
        </Text>
      </Box>
    );
  };

  useEffect(() => {
    let interval = setInterval(() => {
      const countdownObj = calculateCountdown(date);
      countdownObj ? setState(countdownObj) : clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [date]);

  if (variant === "plain" && state.days > 0) {
    return (
      <Text display="inline-block" {...rest}>
        {addLeadingZeros(state.days)}d:{addLeadingZeros(state.hours)}h:
        {addLeadingZeros(state.min)}m:{addLeadingZeros(state.sec)}s
      </Text>
    );
  }

  if (variant === "plain" && !state.days) {
    return (
      <Text display="inline-block" {...rest}>
        {addLeadingZeros(state.hours)}h:
        {addLeadingZeros(state.min)}m:{addLeadingZeros(state.sec)}s
      </Text>
    );
  }
  return (
    <Box className="Countdown" {...rest}>
      <SingleDisplay time={state.days}>
        {state.days === 1 ? "Day" : "Days"}
      </SingleDisplay>

      <SingleDisplay time={state.hours}>Hours</SingleDisplay>

      <SingleDisplay time={state.min}>Min</SingleDisplay>
      <SingleDisplay time={state.sec} mr={0}>
        Sec
      </SingleDisplay>
    </Box>
  );
};

export default Countdown;
